import React from "react";
import logo from "../../assets/Vcars.png";
import footcar from "../../assets/Black-Car-PNG-HD.png";
import icon from "../../assets/ri_building-fill.png";
import phone from "../../assets/Component 10.png";
import email from "../../assets/material-symbols_mail.png";
import insta from "../../assets/ri_instagram-fill.png";
import fb from "../../assets/devicon-plain_facebook.png";
import ld from "../../assets/uiw_linkedin.png";
import x from "../../assets/fa6-brands_square-x-twitter.png";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <>
      <div
        id="footer"
        className="flex flex-col lg:flex-row justify-center gap-4 bg-white py-8 mx-4"
        style={{ fontFamily: "Barlow Condensed" }}
      >
        <section className="flex flex-col justify-center items-center bg-neutral-800 text-white gap-4 pt-8 rounded-2xl">
          <img src={logo} alt="logo" className="w-60 h-38" />
          <img src={footcar} alt="footcar" className="h-72 w-max" />
        </section>

        <section className="flex flex-col justify-center items-center text-center bg-neutral-800 text-white w-full lg:w-1/4 rounded-2xl p-4">
          <h4 className="text-3xl mb-6" style={{ fontFamily: "Ballega" }}>
            Contact Information
          </h4>
          <div className="flex flex-col items-center">
            <div className="flex gap-2 text-xl">
              <img src={icon} alt="icon" className="w-6 h-6" />
              <h6>Address</h6>
            </div>
            <p className="text-lg w-full md:w-3/4 mx-auto">
              8-3-833/179 Indra Nagar, Green Bawarchi Line, beside Laxmi
              Ganapathi Curry Point, Srinagar Colony, Kamalapuri Colony,
              Hyderabad, Telangana 500073
            </p>
          </div>
          <div className="flex gap-2 mt-4 text-md xl:text-xl mb-4">
            <img src={phone} alt="phone" className="w-6 h-6" />
            <p className="lg:text-start">Phone</p> :<p>9290900004</p>,
            <p>9121314181</p>
          </div>
          <div className="flex lg:flex-col lg:items-center xl:flex-row xl:items-none gap-2 lg:gap-0 xl:gap-2">
            <div className="flex lg:justify-center items-center xl:flex-row lg:justify-none lg:items-none gap-2 text-lg md:text-xl">
              <img src={email} alt="email" className="w-6 h-6" />
              <p className="lg:text-start pr-1">E-Mail</p>
            </div>
            <span className="lg:hidden xl:inline">:</span>
            <p className="pl-1 text-lg md:text-xl">
              contact@vexoticcars.com
            </p>
          </div>

          <section className="flex md:flex-row justify-center gap-6 mt-12">
            <Link
              to="/ppf"
              className="p-2 bg-neutral-700 hover:bg-neutral-500 hover:text-black rounded-md"
            >
              PPF
            </Link>
            <Link
              to="/ceramic"
              className="p-2 bg-neutral-700 hover:bg-neutral-500 hover:text-black rounded-md"
            >
              Ceramic
            </Link>
            <Link
              to="/graphene"
              className="p-2 bg-neutral-700 hover:bg-neutral-500 hover:text-black rounded-md"
            >
              Graphine
            </Link>
          </section>
        </section>

        <section className="flex lg:flex-col justify-evenly items-center bg-neutral-800 text-white gap-4 w-full lg:w-2/12 rounded-2xl p-4">
          <h4 className="sm:text-3xl" style={{ fontFamily: "Ballega" }}>
            Social <br /> Media
          </h4>
          <button
            onClick={() =>
              window.open(
                "https://www.instagram.com/v_exotic_cars_v_ceramic_studio/",
                "_blank"
              )
            }
            className="flex flex-col items-center"
          >
            <img src={insta} alt="instagram" className="w-12 h-12" />
            <p>Instagram</p>
          </button>
          <button
            onClick={() =>
              window.open(
                "https://www.facebook.com/profile.php?id=61570011824071/",
                "_blank"
              )
            }
            className="flex flex-col items-center"
          >
            <img src={fb} alt="facebook" className="w-12 h-12" />
            <p>Facebook</p>
          </button>
          {/* <button
            onClick={() => window.open("http://www.linkedin.com/", "_blank")}
            className="flex flex-col items-center"
          >
            <img src={ld} alt="linkedin" className="w-12 h-12" />
            <p>Linkedin</p>
          </button> */}
          <button
            onClick={() => window.open("https://x.com/VExoticCars/", "_blank")}
            className="flex flex-col items-center"
          >
            <img src={x} alt="twitter" className="w-12 h-12" />
            <p>Twitter</p>
          </button>
        </section>
      </div>

      <p
        className="text-xl mb-6 bg-white text-center"
        style={{ fontFamily: "Ballega" }}
      >
        © All rights reserved 2024{" "}
        <span className="text-sky-600">by V-Exotic Cars</span>
      </p>
    </>
  );
};

export default Footer;
